import PropTypes from 'prop-types'
import { Modal, Button } from 'react-bootstrap'
import {
  LaunchPadContainer,
  BulletinContainer,
  CustomerSwitcherContainer
} from 'containers'
import styled, { css } from 'styled-components'
import FeedbackForm from './FeedbackForm'
import phone from '../../assets/images/phone-call.svg'
import phoneActive from '../../assets/images/phone-call-active.svg'

const StyledModal = styled(Modal)`
  .modal-dialog {
    position: relative;
    width: 100%;
  }

  .modal-content {
    display: grid;
    grid-template-rows: 1fr 3fr;
    background: transparent;
    justify-self: center;
    align-self: center;
    box-shadow: none;
    border: none;
  }

  @media only screen and (max-width: 1100px) {
    .modal-content {
      grid-template-columns: 1fr;
      grid-gap: 5rem;
    }
  }

  @media only screen and (max-width: 768px) {
    .modal-content {
      grid-gap: 0rem;
    }
    .modal-dialog {
      margin: 0px;
    }
  }
`
const CallButton = styled(Button)`
  background: none;
  border: none;
  min-width: 15.1rem;
  height: 20.1rem;
  justify-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:active,
  &:active:focus,
  &:focus {
    background: none;
    border: none;
    outline: 0;
  }
  &:hover {
    background-color: #414141;
    transition: all 0.5s ease;

    img {
      animation: wiggle 0.1s alternate ease infinite;
    }
  }

  span {
    font-weight: 700;
    line-height: 1.5rem;
    color: #f2f2f2;
    font-size: 2rem;
    display: block;
    margin-top: 3.2rem;
  }

  img {
    width: 10rem;
    height: 10rem;
  }

  @keyframes wiggle {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(10deg);
    }
  }

  @media only screen and (max-width: 768px) {
    justify-self: inherit;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }
`

const Buttons = styled.div`
  display: flex;
  min-width: 20vw;
  position: absolute;
  left: 60vw;
  justify-content: space-evenly;
  top: 6%;
  gap: 20px;

  @media only screen and (max-width: 1100px) {
    flex-direction: column;
    left: 60vw;
  }
  
  @media only screen and (max-width: 768px) {
    left: 60vw;
  }
`

const StopButtonContainer = styled.div`
  margin-left: 10px;

  @media only screen and (max-width: 768px) {
    margin-left: 0px;
    display: flex;
    order: 1;
  }
`

const StopButton = styled(Button)`
  background: linear-gradient(90deg, #e53935 0%, #e35d5b 100%);
  color: #f2f2f2;
  border: none;
  font-size: 1.5rem;
  font-weight: 700;
  border-radius: 1.5rem;
  padding: 1rem;

  &:hover,
  &:active,
  &:active:focus,
  &:focus {
    color: #f2f2f2;
  }

  &:active {
    color: #f2f2f2;
    background: linear-gradient(90deg, #e53935 0%, #e35d5b 100%);
  }

  img {
    width: 1.8rem;
    height: 1.8rem;
  }

  @media only screen and (max-width: 768px) {
    margin-bottom: 1rem;
  }
`

const LaunchPad = styled.div`
  display: flex;
  margin: auto;

  & > div {
    height: 35rem;
    width: 55rem;
    margin-top: 1rem;
  }

  @media only screen and (max-width: 1101px) {
    display: block;
  }

  @media only screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    margin: 0;

    & > div {
      height: 100%;
      width: 90%;
      margin: auto;
      margin-bottom: 30px;
    }
  }
`
const LogoutButton = styled(Button)`
  border-radius: 1rem;
  background-color: transparent;
  color: var(--white);
  font-size: 1.6rem;
  font-weight: 700;
  border: 4px solid var(--main-color);
  max-height: 50px;

  &:hover,
  &:active,
  &:active:focus,
  &:focus {
    background-color: #414141;
    color: var(--white);
    border: 0.5rem solid var(--main-color);
  }

  @media only screen and (max-width: 768px) {
    border: 4px solid red;
    background-color: red;
  }
`

const CallHandler = ({
  handleStart,
  handleFinish,
  isStarted,
  showFeedback,
  handleFeedback,
  inputInfo,
  clientId,
  handleChange,
  startSessionText = 'Start Session',
  endSessionText = 'End Session',
  clientIdInputEnabled,
  logout,
  validationMessage,
  validInput,
  inputPlaceholder,
  feedbackButtons,
  hideFeedback,
  ...props
}) => {
  return (
    <StopButtonContainer>
      {isStarted && (
        <StopButton onClick={handleFinish} id="stopCall">
          <img src={phoneActive} alt={`${endSessionText?.trim() ?? 'End Session'} button`} /> {endSessionText?.trim() ?? 'End Session'}
        </StopButton>
      )}
      {showFeedback && (
        <FeedbackForm
          handleChange={handleChange}
          validationMessage={validationMessage}
          validInput={validInput}
          clientInput={clientIdInputEnabled}
          inputPlaceholder={inputPlaceholder}
          clientId={clientId}
          handleClick={handleFeedback}
          inputInfo={inputInfo}
          feedbackButtons={feedbackButtons}
          hideFeedback={hideFeedback}
          {...props}
        />
      )}
      <StyledModal show={!isStarted}>
        <CallButton onClick={handleStart}>
          <img src={phone} alt={`${startSessionText?.trim() ?? 'Start Session'} button`} />
          <span>{startSessionText?.trim() ?? 'Start Session'}</span>
        </CallButton>
        <LaunchPad>
          <LaunchPadContainer height="300px" />
          <BulletinContainer height="300px" />
        </LaunchPad>
        <Buttons>
          <CustomerSwitcherContainer isStarted={isStarted} />
          <LogoutButton onClick={logout}>Logout</LogoutButton>
        </Buttons>
      </StyledModal>
    </StopButtonContainer>
  )
}

CallHandler.propTypes = {
  handleStart: PropTypes.func.isRequired,
  handleFinish: PropTypes.func.isRequired,
  isStarted: PropTypes.bool.isRequired,
  showFeedback: PropTypes.bool.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  inputInfo: PropTypes.string,
  clientId: PropTypes.string.isRequired,
  handleChange: PropTypes.func.isRequired,
  startSessionText: PropTypes.string,
  endSessionText: PropTypes.string,
  clientIdInputEnabled: PropTypes.bool,
  logout: PropTypes.func.isRequired,
  validationMessage: PropTypes.string.isRequired,
  validInput: PropTypes.string,
  inputPlaceholder: PropTypes.string,
  feedbackButtons: PropTypes.array,
  hideFeedback: PropTypes.func.isRequired
}

export default CallHandler
